// Navbar.tsx
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../utils/useAuth";
import { colors, spacing, borderRadius, shadows, typography, createBadgeStyle } from "../styles/theme";

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (!user) return null;

  const isActive = (path: string) => location.pathname === path;

  const navLinkStyle = (path: string) => ({
    padding: `${spacing.sm}px ${spacing.lg}px`,
    marginRight: spacing.sm,
    textDecoration: 'none',
    color: isActive(path) ? colors.primary : colors.textPrimary,
    background: isActive(path) ? colors.primaryLight : 'transparent',
    borderRadius: borderRadius.sm,
    fontWeight: isActive(path) ? typography.fontWeight.semibold : typography.fontWeight.normal,
    fontSize: typography.fontSize.base,
    transition: 'all 0.2s ease',
    display: 'inline-block',
  });

  return (
    <nav style={{
      padding: `${spacing.md}px ${spacing.xl}px`,
      borderBottom: `1px solid ${colors.border}`,
      background: colors.background,
      boxShadow: shadows.sm,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}>
      {/* Logo / Brand */}
      <div style={{ display: 'flex', alignItems: 'center', gap: spacing.lg }}>
        <Link to="/dashboard" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: spacing.sm }}>
          <span style={{
            fontSize: typography.fontSize.xl,
            fontWeight: typography.fontWeight.bold,
            color: colors.primary,
          }}>
            📊 Faktury Semtop
          </span>
        </Link>
      </div>

      {/* Navigation Links */}
      <div style={{ display: 'flex', alignItems: 'center', gap: spacing.xs }}>
        <Link to="/dashboard" style={navLinkStyle('/dashboard')}>
          🏠 Dashboard
        </Link>
        <Link to="/drafts" style={navLinkStyle('/drafts')}>
          📝 Drafty
        </Link>
        <Link to="/issued" style={navLinkStyle('/issued')}>
          📄 Wystawione
        </Link>
        <Link to="/allegro-clients" style={navLinkStyle('/allegro-clients')}>
          👥 Klienci Ads
        </Link>
        {user.role === "admin" && (
          <Link to="/admin" style={{
            ...navLinkStyle('/admin'),
            background: isActive('/admin') ? colors.warningLight : colors.backgroundAlt,
            color: isActive('/admin') ? colors.warningDark : colors.textSecondary,
            fontWeight: typography.fontWeight.medium,
          }}>
            ⚙️ Admin
          </Link>
        )}
      </div>

      {/* User Info & Logout */}
      <div style={{ display: 'flex', alignItems: 'center', gap: spacing.md }}>
        <span style={{
          fontSize: typography.fontSize.sm,
          color: colors.textSecondary,
          padding: `${spacing.xs}px ${spacing.sm}px`,
          background: colors.gray100,
          borderRadius: borderRadius.full,
        }}>
          {user.email}
          {user.role === 'admin' && (
            <span style={{
              ...createBadgeStyle('warning'),
              marginLeft: spacing.xs,
            }}>
              Admin
            </span>
          )}
        </span>
        <button
          onClick={handleLogout}
          style={{
            padding: `${spacing.sm}px ${spacing.lg}px`,
            background: colors.errorLight,
            color: colors.errorDark,
            border: `1px solid ${colors.error}`,
            borderRadius: borderRadius.sm,
            cursor: 'pointer',
            fontWeight: typography.fontWeight.medium,
            fontSize: typography.fontSize.sm,
            transition: 'all 0.2s ease',
          }}
        >
          🚪 Wyloguj
        </button>
      </div>
    </nav>
  );
};
export default Navbar;
